// extracted by mini-css-extract-plugin
export default {"left":"Left_left__R-KwJ"};